import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Insight from "@/pages/Insight";
import MacdConnect from "@/pages/MacdConnect";
import MacdConnectPagamento from "@/pages/MacdConnectPagamento";
import MacdConnectConfirmado from "@/pages/MacdConnectConfirmado";
import LiveOasys from "@/pages/LiveOasys";
import AdminLogin from "@/pages/AdminLogin";
import AdminMacdConnect from "@/pages/AdminMacdConnect";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/insights/:slug" element={<Insight />} />
          <Route path="/macd-connect" element={<MacdConnect />} />
          <Route
            path="/macd-connect/pagamento"
            element={<MacdConnectPagamento />}
          />
          <Route
            path="/macd-connect/confirmado"
            element={<MacdConnectConfirmado />}
          />
          <Route path="/live" element={<LiveOasys />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/macd-connect" element={<AdminMacdConnect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors theme="dark" />
    </div>
  );
}

export default App;
